// src/i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your translation files
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";
import translationRU from "./locales/ru/translation.json";

// The translations
const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  ru: {
    translation: translationRU,
  },
};

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .use(LanguageDetector) // Detects user language
  .init({
    resources,
    fallbackLng: "en", // Use 'en' if detected language is not available

    keySeparator: ".", // We do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
  });

export default i18n;
